export default function Hero() {
  const handleGetQuote = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://ik.imagekit.io/pianomoverslondon/tr:w-1200,h-800,c-at_max,q-85,f-webp/Piano%20Movers%20Gallery%20London%20Jobs/Piano_Movers_London_Pictures_from_job%20(5).jpeg"
          alt="Upright piano removal London — two specialists carrying piano on stairs"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>
      
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center text-white">
        <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
          Upright Piano Removal London
        </h1>
        <p className="text-xl md:text-2xl mb-8 text-white/95">
          Specialist upright piano movers serving all 32 London boroughs
        </p>
        <button
          onClick={handleGetQuote}
          className="bg-[#c9a84c] hover:bg-[#b89740] text-[#0e0d0b] px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
        >
          Get Upright Piano Quote
        </button>
      </div>
    </section>
  );
}